// choices/paletteChoices.js
import { images } from "../../components/utility/imageImports";

const paletteChoicesBg = [
  {
    label: "Син",
    value: "blues",
    imageUrl: images["blues.png"],
  },
  {
    label: "Зелен",
    value: "greens",
    imageUrl: images["greens.png"],
  },
  {
    label: "Жълт",
    value: "yellows",
    imageUrl: images["yellows.png"],
  },
  {
    label: "Червен",
    value: "reds",
    imageUrl: images["reds.png"],
  },
  {
    label: "Оранжев",
    value: "oranges",
    imageUrl: images["oranges.png"],
  },
  {
    label: "Виолетов",
    value: "violets",
    imageUrl: images["violets.png"],
  },
  {
    label: "Бял",
    value: "whites",
    imageUrl: images["whites.png"],
  },
  {
    label: "Сив",
    value: "grays",
    imageUrl: images["grays.png"],
  },
  {
    label: "Кафяв",
    value: "browns",
    imageUrl: images["browns.png"],
  },
];

export default paletteChoicesBg;
